import { isPhoneInLandscape } from '../../../../styles'

export default () =>
  ({
    default: {
      wrap: {
        padding: '32px 48px 40px',

        [isPhoneInLandscape]: {
          padding: '32px',
        },
      },
    },

    children: {
      wrap: {
        padding: '16px 48px 40px',

        [isPhoneInLandscape]: {
          display: 'flex',
          flexDirection: 'column',
          padding: '16px 32px 32px',
        },

        '& > button': {
          '&:first-of-type': {
            marginInlineEnd: '16px',

            [isPhoneInLandscape]: {
              marginBottom: '8px',
              marginInlineEnd: 0,
            },
          },
        },
      },
    },
  }) as const
